import { render, staticRenderFns } from "./ReceiptBucket.vue?vue&type=template&id=7b68723c&scoped=true&"
import script from "./ReceiptBucket.vue?vue&type=script&lang=js&"
export * from "./ReceiptBucket.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptBucket.vue?vue&type=style&index=0&id=7b68723c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b68723c",
  null
  
)

export default component.exports